import axios from "./axios";

export function pointsRequest(path, data = {}) {
  return axios.post("/mapi/api/points/" + path, data, {
    headers: { client_type: "h5" }
  }).then(response => {
    if (!response || response.success === false) {
      throw new Error((response && response.respMsg) || "请求失败，请重试");
    }
    return response.data;
  });
}

export function groupPointsRows(rows) {
  const groups = [];
  rows.forEach(row => {
    const match = /^(\d{4})-(\d{2})/.exec(row.time || "");
    const month = match ? `${match[1]}年${Number(match[2])}月` : "其他";
    let group = groups.find(item => item.month === month);
    if (!group) {
      group = { month, rows: [] };
      groups.push(group);
    }
    group.rows.push(row);
  });
  return groups;
}



// WEBPACK FOOTER //
// ./src/api/points.js